import { WIDGET } from "@voltmoney/schema";
import { LAYOUTS } from "@voltmoney/types";
import { ROUTE } from "../../routes";
import { ACTION } from "./types";
import { faqsAction, goBackAction, needHelpAction, createNewApplication } from "./actions";
import SharedPropsService from "../../SharedPropsService";
export const template = (height, accountId) => ({
    layout: {
        id: ROUTE.ELEVATE_LANDING,
        type: LAYOUTS.LIST,
        widgets: [
            {
                id: 'elevateLanding', type: WIDGET.ELEVATE_LANDING
            }
        ],
    },
    datastore: {
        elevateLanding: {
            height: height,
            faqsAction: {
                type: ACTION.FAQS_DIRECT,
                routeId: ROUTE.ELEVATE_LANDING,
                payload: {}
            },
            goBack: {
                type: ACTION.GO_BACK,
                routeId: ROUTE.ELEVATE_LANDING,
                payload: {}
            },
            needHelpAction: {
                type: ACTION.NEED_HELP,
                routeId: ROUTE.ELEVATE_LANDING,
                payload: {}
            },
            createNewApplication: {
                type: ACTION.CREATE_DSP_APPLICATION,
                routeId: ROUTE.ELEVATE_LANDING,
                payload: {
                    accountId: accountId
                }
            }
        }
    },
});
export const elevateLandingMF = {
    onLoad: async ({ getHeight }) => {
        const userData = await SharedPropsService.getUser();
        const accountId = userData && userData?.linkedApplications[0]?.accountId;
        return Promise.resolve(template(getHeight(), accountId));
    },
    actions: {
        [ACTION.FAQS_DIRECT]: faqsAction,
        [ACTION.GO_BACK]: goBackAction,
        [ACTION.NEED_HELP]: needHelpAction,
        [ACTION.CREATE_DSP_APPLICATION]: createNewApplication,
    }
};
